// PRC-016 / PRC-017: servicios públicos de cuenta (reenvío del enlace y recuperar contraseña).
import axios from 'axios';
import axiosInstance from '../../config/axiosInstance';

export type EmailRequestResult = 'sent' | 'limited' | 'offline' | 'error';

const classify = (err: unknown): EmailRequestResult => {
  if (axios.isAxiosError(err)) {
    if (err.response?.status === 429) return 'limited';
    if (!err.response) return 'offline';
  }
  return 'error';
};

export async function resendConfirmation(email: string): Promise<EmailRequestResult> {
  try {
    await axiosInstance.post('/auth/resend-confirmation', { email });
    return 'sent';
  } catch (err) {
    return classify(err);
  }
}

export async function requestPasswordReset(email: string): Promise<EmailRequestResult> {
  try {
    await axiosInstance.post('/auth/request-password-reset', { email });
    return 'sent';
  } catch (err) {
    return classify(err);
  }
}

export const MIN_PASSWORD_LENGTH = 8;
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// PRC-030: el primer campo con error recibe el foco (pares [error, id del campo], en orden).
export const focusFirstError = (fields: Array<[unknown, string]>): void => {
  const hit = fields.find(([error]) => !!error);
  if (hit) document.getElementById(hit[1])?.focus();
};
export const RESEND_WAIT_SECONDS = 60;
export const OFFLINE_MESSAGE = 'No hemos podido conectar. Revisa tu conexión y vuelve a intentarlo.';

// Errores que Supabase deja en la URL al abrir un enlace caducado o ya usado.
export const linkErrorInUrl = (): boolean => {
  const params = new URLSearchParams(window.location.hash.replace(/^#/, '') || window.location.search);
  return !!(params.get('error') || params.get('error_code'));
};

// PRC-025: primer acceso de una cuenta nueva = se llega desde /cuenta-confirmada.
const FIRST_ACCESS_KEY = 'proa-pricing-first-access';

export const markFirstAccess = (): void => {
  try { window.sessionStorage.setItem(FIRST_ACCESS_KEY, '1'); } catch { /* sin almacenamiento: texto general */ }
};

export const isFirstAccess = (): boolean => {
  try { return window.sessionStorage.getItem(FIRST_ACCESS_KEY) === '1'; } catch { return false; }
};

export const clearFirstAccess = (): void => {
  try { window.sessionStorage.removeItem(FIRST_ACCESS_KEY); } catch { /* nada que limpiar */ }
};
